import UnicornApp from '../app';
export default class UnicornLang {
    app;
    static get is() { return 'lang'; }
    static install(app) {
        const $lang = app.$lang = new this(app);
        app.__ = $lang.__.bind($lang);
        app.trans = $lang.trans.bind($lang);
    }
    constructor(app) {
        this.app = app;
        //
    }
    __(text, ...args) {
        return this.trans(text, ...args);
    }
    /**
     * Translate a string.
     */
    trans(text, ...args) {
        const key = this.normalize(text);
        let translated = this.find(key) || '';
        if (args.length) {
            translated = this.sprintf(translated, ...args);
        }
        return translated !== '' ? translated : this.wrapDebug(text, false);
    }
    /**
     * Sptintf language string.
     */
    sprintf(text, ...args) {
        return this.app.vsprintf(text, args);
    }
    /**
     * Find text.
     */
    find(key) {
        const langs = this.getStrings();
        if (langs[key]) {
            return langs[key];
        }
        return null;
    }
    /**
     * Has language key.
     */
    has(key) {
        const langs = this.getStrings();
        return langs[key] !== undefined;
    }
    /**
     * Add language key.
     */
    add(key, value) {
        const data = this.getStrings();
        data[this.normalize(key)] = value;
        this.app.data('unicorn.languages', data);
        return this;
    }
    /**
     * Replace all symbols to dot(.).
     */
    normalize(text) {
        return text.replace(/[^A-Z0-9]+/ig, '.');
    }
    wrapDebug(text, success) {
        if (this.app.isDebug()) {
            if (success) {
                return '**' + text + '**';
            }
            return '??' + text + '??';
        }
        return text;
    }
    getStrings() {
        return this.app.data('unicorn.languages') || {};
    }
}
